import memoizeOne from 'memoize-one';

export const calculateAlerts = (info, limits) => {
  let alerts = [];

  if (limits && info) {
    const applicableLimits = limits.filter(
      limit =>
        info.ageInMonths >= limit.ageFrom && info.ageInMonths <= limit.ageTo,
    );
    alerts = applicableLimits.reduce(function(prev, limit) {
      const patientValue = info[limit.name];
      const value =
        limit.name === 'bpS'
          ? `${patientValue}/${info.bpD}`
          : limit.name === 'bpD'
            ? `${info.bpS}/${patientValue}`
            : patientValue;
      const name =
        limit.name === 'bpS' || limit.name === 'bpD' ? 'BP' : limit.label;
      let displayedLimit;

      if (limit.criticalFrom !== null && patientValue >= limit.criticalFrom) {
        displayedLimit = { name: name, value: value, class: 'danger' };
      } else if (
        limit.moderateFrom !== null &&
        patientValue >= limit.moderateFrom
      ) {
        displayedLimit = { name: name, value: value, class: 'warning' };
      } else if (
        limit.normalFrom !== null &&
        patientValue !== null &&
        patientValue < limit.normalFrom
      ) {
        displayedLimit = { name: name, value: value, class: 'danger' };
      } else {
        return prev;
      }
      // The code below make sense only when bpS and bpD have different levels of alert
      if (limit.name === 'bpD') {
        if (prev.some(val => val.name === 'BP')) {
          const bp = prev.filter(val => val.name === 'BP');
          const bpClass = bp.map(val => val.class).join();
          if (bpClass === 'warning' && displayedLimit.class === 'danger') {
            const replaceIndex = prev.map(val => val.name).indexOf('BP');
            prev.splice(replaceIndex, 1, {
              ...bp[0],
              class: displayedLimit.class,
            });
          }
          return prev;
        }
      }
      return [...prev, displayedLimit];
    }, []);
  }

  return alerts;
};

export const getAlerts = memoizeOne(calculateAlerts);

export const getAlertClass = memoizeOne((alerts, propertyName) => alerts.filter(el => el.name === propertyName).map(el => el.class));



// WEBPACK FOOTER //
// ./src/routes/management/utils/alerts.js